var translation = {
	Navatar: {
		header: "AWS-Profil",
		subheader: "Ihr Profil hilft, Ihre Interaktionen mit ausgewählten AWS-Diensten zu verbessern.",
		profileButtonText: "Profil anzeigen",
		logOutText: "Abmelden",
		logInText: "Einloggen",
		createProfileText: "Profil erstellen",
		federateLoginModalTitle: "Midway für den Zugriff auf Ihr AWS-Profil verwenden",
		federateLoginModalFirstDescription: "Als Amazon-Mitarbeiter empfehlen wir, Midway für den Zugriff auf Ihr AWS-Profil zu verwenden. Diese von der Sicherheit empfohlene Methode ermöglicht eine nahtlose Integration mit internen Systemen.",
		federateLoginModalSecondDescription: "Diese Meldung wird angezeigt, weil Sie sich mit einer Amazon-E-Mail-Adresse unter Verwendung der AWS Builder ID angemeldet haben. Diese Aufforderung erscheint jedes Mal, wenn Sie sich anmelden, bis Sie zu Midway wechseln oder mit Ihrer aktuellen Anmeldung fortfahren möchten.",
		federateLoginModalPrimaryButton: "Mit Midway anmelden",
		federateLoginModalSecondaryButton: "Mit der AWS Builder ID fortfahren"
	}
};
var Navatar = {
	translation: translation
};

export { Navatar as default, translation };
